import { ReactNode } from 'react';
import styled from 'styled-components';

import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';

interface IProps {
	title: string;
	children: ReactNode;
}

const Element = styled.ol`
	counter-reset: OrderedList-counter;
	display: block;
`;

export default function OrderedList({ title, children }: IProps) {
	return (
		<>
			<SectionTitle color="antracite">{title}</SectionTitle>
			<Column py={2}>
				<Element>{children}</Element>
			</Column>
		</>
	);
}

export const OrderedListItem = styled.li`
	color: ${(props) => props.theme.colors.slateBlue};
	line-height: 1.8;
	counter-increment: OrderedList-counter;
	list-style: none;

	&:before {
		content: counter(OrderedList-counter) '.';
		font-size: 18px;
		margin-right: 10px;
		color: ${(props) => props.theme.colors.antracite};
	}
`;
